import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import store from './store'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Services from './services'

Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.prototype.$REGEX = {
  mobile: /^1[3-9]\d{9}$/
}

Vue.prototype.$GetTradeType = () => {
  if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
    return 'JSAPI'
  } else {
    return 'MWEB'
  }
}

Vue.use(ElementUI);
Vue.use(Services);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
